import { Radio } from "lucide-react";
import { formatResultValue } from "@/utils/format";

export function LiveTicker({ items = [] }) {
  const active = items.filter(Boolean);
  if (active.length === 0) return null;

  const content = active.map((it) => {
    const value = it.result_value || formatResultValue(it);
    return `${it.category_name}: ${value}`;
  });
  const doubled = [...content, ...content];

  return (
    <div data-testid="live-ticker" className="relative flex items-center gap-2 overflow-hidden border-y-2 border-[#FFD700] bg-gradient-to-r from-[#5A0A14] via-[#7A1020] to-[#5A0A14] py-3">
      <span className="live-fx z-10 ml-2 inline-flex shrink-0 items-center gap-1 rounded-full px-3 py-1 text-xs font-black uppercase shadow">
        <Radio className="h-3.5 w-3.5" /> Live
      </span>
      <div className="min-w-0 flex-1 overflow-hidden">
        <div className="marquee-track">
          {doubled.map((text, i) => (
            <span key={`${i}-${text}`} className="mx-6 font-mono text-base font-extrabold sm:text-lg">
              <span className="text-[#FFE27A]">{text.split(": ")[0]}:</span> <span className="text-white">{text.split(": ").slice(1).join(": ")}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
